module.exports = __webpack_public_path__ + "img/161.fdac909c.jpg";